import { Modal, Avatar, Button } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { removeTeamMember } from "../../../actions/companyActions";
import { UserOutlined } from "@ant-design/icons";
import { usePreviousState } from "../../../utils/customHooks";
import "./style.css";
import GalkButton from "../../common/component/button";

const DeleteProjectModal = ({
	modalCloseHandler,
	isActionProgress,
	member,
	removeTeamMember,
}) => {
	const { t } = useTranslation();
	const prevActionInProgressValue = usePreviousState(isActionProgress);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			modalCloseHandler();
		}
	}, [isActionProgress]);

	const deleteMember = () => {
		removeTeamMember(member);
		modalCloseHandler();
	};

	return (
		<Modal
			title={`${t("accountSetting_deleteModal_title")} ?`}
			visible={true}
			onCancel={modalCloseHandler}
			footer={null}
		>
			<div className="teamMember_deleteMember_modalBody_container">
				<div className="teamMember_deleteMember_modalBody">
					<div className="avatar">
						{member.profilePic ? (
							<Avatar size={50} src={member.profilePic} />
						) : (
							<Avatar size={50} icon={<UserOutlined />} />
						)}
					</div>
					<div className="details">
						<div className="name">{member.name}</div>
						<div className="role">{member.role}</div>
						<div className="email">{member.email}</div>
					</div>
				</div>
				<div className="project-form-controls-cont">
					<GalkButton
						type="primary"
						additionalStyle={{ padding: "13px 16px" }}
						onClick={deleteMember}
					>
						{t("accountSetting_deleteModal_actionButton_delete")}
					</GalkButton>
				</div>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.company.company.loading,
});

export default connect(mapStateToProps, { removeTeamMember })(
	DeleteProjectModal
);
